export const toLocalString = (number: number, currency: string) => {
  return number.toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "currency",
    currency,
  });
};
